/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Center_Center_Justify_Center_PosInputs */

const en_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Center Justify / Center Position`)
};

const fr_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justification Centree / Position Centree`)
};

const de_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zentriert ausrichten / Zentrierte Position`)
};

const it_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allineamento al centro / Posizione centrale`)
};

const ru_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Центрирование по выравниванию / Центрирование по позиции`)
};

const es_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justificar al centro / Posición centrada`)
};

const zh_cn2_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`居中对齐 / 居中位置`)
};

const ja_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`中央揃え / 中央位置`)
};

const hi_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`केंद्र में रखें / केंद्र में रखें`)
};

const pt_pt2_align_center_center_justify_center_pos = /** @type {(inputs: Align_Center_Center_Justify_Center_PosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Centralizar Justificar / Posicionamento Centralizado`)
};

/**
* | output |
* | --- |
* | "Center Justify / Center Position" |
*
* @param {Align_Center_Center_Justify_Center_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_center_center_justify_center_pos = /** @type {((inputs?: Align_Center_Center_Justify_Center_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Center_Center_Justify_Center_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_align_center_center_justify_center_pos(inputs)
	if (locale === "de") return de_align_center_center_justify_center_pos(inputs)
	if (locale === "it") return it_align_center_center_justify_center_pos(inputs)
	if (locale === "ru") return ru_align_center_center_justify_center_pos(inputs)
	if (locale === "es") return es_align_center_center_justify_center_pos(inputs)
	if (locale === "zh-CN") return zh_cn2_align_center_center_justify_center_pos(inputs)
	if (locale === "ja") return ja_align_center_center_justify_center_pos(inputs)
	if (locale === "hi") return hi_align_center_center_justify_center_pos(inputs)
	if (locale === "pt-PT") return pt_pt2_align_center_center_justify_center_pos(inputs)
	return en_align_center_center_justify_center_pos(inputs)
});